(function() {
  const footers = document.querySelectorAll('.bigmad-footer');
  if (!footers.length) return;

  const mqDesktop = window.matchMedia('(min-width: 750px)');

  function syncDetailsState() {
    const isDesktop = mqDesktop.matches;
    footers.forEach(footer => {
      footer.querySelectorAll('.bigmad-footer-details').forEach(d => {
        if (isDesktop) {
          d.setAttribute('open', '');
        } else {
          d.removeAttribute('open');
        }
      });
    });
  }

  footers.forEach(footer => {
    // Newsletter — feedback visual no submit
    const form = footer.querySelector('.bigmad-footer-newsletter-form');
    if (form) {
      const submitBtn = form.querySelector('.bigmad-footer-newsletter-submit');
      form.addEventListener('submit', () => {
        if (submitBtn) {
          submitBtn.disabled = true;
          const span = submitBtn.querySelector('span');
          if (span) {
            span.dataset.original = span.textContent;
            span.textContent = 'Enviando...';
          }
        }
      });
    }

    // No desktop, previne que o user feche o details acidentalmente
    footer.querySelectorAll('.bigmad-footer-details').forEach(d => {
      d.addEventListener('toggle', () => {
        if (mqDesktop.matches && !d.open) {
          d.setAttribute('open', '');
        }
      });
    });
  });

  // Roda no carregamento e sempre que a tela mudar de tamanho
  syncDetailsState();
  mqDesktop.addEventListener('change', syncDetailsState);

  // Localization forms — submit ao trocar
  document.querySelectorAll('.bigmad-footer-loc-form select').forEach(select => {
    select.addEventListener('change', (e) => {
      const form = e.target.closest('.bigmad-footer-loc-form');
      if (form) form.submit();
    });
  });
})();